import { Component, Input,  TemplateRef } from '@angular/core';

@Component({
  selector: 'app-generic-tooltip',
  templateUrl: './generic-tooltip.component.html',
  styleUrls: ['./generic-tooltip.component.scss']
})
export class GenericTooltipComponent {

  @Input() tooltip!: any;
  @Input() left!: number;
  @Input() top!: number;
  @Input() position: string = '';
  @Input() anchorPos: string = '';
  childTemplate: TemplateRef<any> | any;
  isStringInput: boolean = false;


}
